// eslint-disable-next-line import/no-extraneous-dependencies
import _ from 'lodash';

import ConditionsManager from './conditions-manager';
import { mergeSatisfiers } from './common';
import issueItemsForAPriceRewards from './issue-items-for-a-price-rewards';
import issueStandardRewards from './issue-standard-rewards';
import issueDiscountToCartRewards from './issue-discount-to-cart-rewards';
import issueDiscountBundleRewards from './issue-discount-bundle-rewards';

const addSatisfiedBy = (conditionsSatisfiers, rewardsSatisfiers) => {
  _.forEach(rewardsSatisfiers, (satisfierOfRewards) => {
    _.forEach(satisfierOfRewards.rewards, (reward) => {
      reward.satisfiedBy = _.reduce(
        conditionsSatisfiers,
        (satisfiedBy, satisfierOfConditions, key) => {
          satisfiedBy[key] = { productId: satisfierOfConditions.item.id, quantity: satisfierOfConditions.quantity };
          return satisfiedBy;
        },
        {}
      );
    });
  });
  return rewardsSatisfiers;
};

const determineRewards = (bogoCalcsData, bogoSpecial, discountTaxOrder, items, globalSpecialsSettings) => {
  const redemptionLimit = bogoSpecial?.redemptionLimit || 1; // 0 redemptionLimits aren't allowed, no coalescing here
  const attemptRedemption = (redemptionIndex) => {
    const conditionsManager = new ConditionsManager(bogoCalcsData, bogoSpecial, items, globalSpecialsSettings);
    const { discountToCart, itemsForAPrice, discountBundle, specialId } = bogoSpecial;

    if (conditionsManager.satisfied) {
      let rewardsSatisfiers;
      let discountToCartRewards;

      if (discountToCart?.enabled) {
        discountToCartRewards = issueDiscountToCartRewards(
          bogoCalcsData,
          bogoSpecial,
          discountTaxOrder,
          items,
          conditionsManager
        );
      } else if (discountBundle?.enabled) {
        rewardsSatisfiers = issueDiscountBundleRewards(bogoCalcsData, bogoSpecial, conditionsManager);
      } else if (itemsForAPrice?.enabled) {
        rewardsSatisfiers = issueItemsForAPriceRewards(
          bogoCalcsData,
          bogoSpecial,
          conditionsManager,
          discountTaxOrder,
          items
        );
      } else {
        rewardsSatisfiers = issueStandardRewards(bogoCalcsData, bogoSpecial, conditionsManager, items);
      }

      if (!_.isEmpty(rewardsSatisfiers) || !_.isEmpty(discountToCartRewards)) {
        // don't add items to condition satisfiers so they can be considered
        // for rewards or other conditions
        // TODO: check if items for a discount should be added here
        if (!itemsForAPrice?.enabled && !discountToCart?.enabled) {
          bogoCalcsData.conditionsSatisfiers = mergeSatisfiers(
            bogoCalcsData.conditionsSatisfiers,
            conditionsManager.satisfiers
          );
          rewardsSatisfiers = addSatisfiedBy(conditionsManager.satisfiers, rewardsSatisfiers);
        }

        if (discountToCart?.enabled) {
          bogoCalcsData.discountToCartSatisfiers = bogoCalcsData.discountToCartSatisfiers ?? {};

          bogoCalcsData.discountToCartSatisfiers[specialId] = mergeSatisfiers(
            bogoCalcsData.discountToCartSatisfiers[specialId],
            conditionsManager.satisfiers
          );
        }

        bogoCalcsData.rewardsSatisfiers = mergeSatisfiers(bogoCalcsData.rewardsSatisfiers, rewardsSatisfiers);

        bogoCalcsData.discountToCartRewards = mergeSatisfiers(
          bogoCalcsData.discountToCartRewards,
          discountToCartRewards
        );

        if (redemptionIndex + 1 < redemptionLimit) {
          attemptRedemption(redemptionIndex + 1);
        }
      }
    }
  };
  attemptRedemption(0);

  return bogoCalcsData;
};

export default determineRewards;
